import React, { useEffect, useState } from 'react'
import { GetPinnedMessages } from '../../services/QualificationService';
import moment from 'moment'
import { useParams } from 'react-router-dom';
import { StandardButton } from '../common/GlobalElements/StandardButton';
import styled from 'styled-components';
import {tokens} from '../../public/tokens';



const tempFilterData = [
    {text : "Assessment",color : "cat-dark-blue",icon : "fa-ballot-check"},
    {text : "Classes",color : "cat-green",icon : "fa-calendar"},
    {text : "Notifications",color : "cat-yellow",icon : "fa-bell"},
    {text : "Mentions",color : "cat-purple",icon : "fa-at"},
    {text : "Replies",color : "cat-blue",icon : "fa-reply"},
    {text : "Unread",color : "cat-red",icon : "fa-comment-exclamation"},
]

/**
 * Styled search bar component for the Newsroom feed.
 * Includes search input, selected filter badge, filter toggle,
 * and responsive styling for desktop and mobile layouts.
*/
export const FeedSearchBar = styled.div({
  position: 'relative',
  width: '434px',
  boxShadow: tokens.effects.effects.shadow.default,

  '& .feed-search-input': {
    width: '100%',
    height: '100%',
    padding: '6px 10px 8px 10px',
    boxSizing: 'border-box',
    fontSize: tokens.typography.fontSize['lg-14px'],
    marginLeft: "20px",
    marginRight: "15px",

    '&:focus': {
      outline: 'none',
      boxShadow: 'none',
    },
  },

  '& .left-icon': {
    position: 'absolute',
    left: '14px',
    top: '50%',
    padding: '7px 5px 5px',
    transform: 'translateY(-50%)',
    color: tokens.colors.neutral.black,
    zIndex: 2,
  },

  '& .filter-item-container': {
    position: 'absolute',
    right: '40px',
    top: '50%',
    transform: 'translateY(-50%)',
    display: 'flex',
    alignItems: 'center',
    zIndex: 2,
    maxWidth: '70%',
    overflow: 'hidden',
  },

  '& .feed-filter-item': {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    padding: '4px 8px',
    background: tokens.colors.ui.muted,
    borderRadius: '12px',
    fontSize: tokens.typography.fontSize['md-12px'],
    lineHeight: 1,
    whiteSpace: 'nowrap',
  },

  '& .remove-filter-item': {
    border: 'none',
    background: 'transparent',
    padding: 0,
    marginLeft: '4px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
  },

  '& > span:last-child': {
    position: 'absolute',
    right: '12px',
    top: '50%',
    transform: 'translateY(-50%)',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
  },

  '& .right-icon': {
    fontSize: tokens.typography.fontSize['lg-14px'],
  },

  '& .feed-filter-count': {
    position: 'absolute',
    top: '2px',
    right: '-5px',
    minWidth: '11px',
    height: '11px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: tokens.typography.fontSize['sm-10px'],
    background: tokens.colors.ui.destructive,
    color: tokens.colors.neutral.white,
  },

  // Override bootstrap
    '&& .feed-search-input': {
        height: '36px',
        borderRadius: '20px',
        boxShadow: 'none',
    },
    '&.has-selected-filter .feed-search-input': {
        width: 'calc(100% - 170px)',
    },
    '@media (max-width: 575px)': {
        fontSize: tokens.typography.fontSize['md-12px'],
        '&& .feed-search-input': {
            height: '30px',
        },
    },
});

export default function FeedToolBar(props) {
    const {sid} = useParams();
    const [showFilter, setShowFilter] = useState(false);
    const [showPinned, setShowPinned] = useState(false);
    const [tempFilter, setTempFilter] = useState([]);
    const [selectedItem, setSelectedItem] = useState([]);
    const [pinnedMessages, setPinnedMessages] = useState([]);
    const [searchTerm, setSearchTerm] = useState(props?.feedSearch || '');
    
    useEffect(() =>{
        return (()=>{            
            props.setAssessmentFilter(0)
            props.setClassFilter(0)
            props.setNotificationFilter(0)
            props.setMentionFilter(0)
            props.setReplyFilter(0)
            props.setUnReadFilter(0)
        })
    },[])
    
    useEffect(()=>{
        const data = tempFilterData.filter(item => !tempFilter.includes(item.text))
        if(data==0){
            setShowFilter(false);
        }
    },[tempFilter])

    const handleFilter = (input) =>{
        const ls = [...tempFilter];
        const allSelected = [...selectedItem];
        ls.push(input.text);
        allSelected.push(input);
        setTempFilter([...ls]);
        setSelectedItem([...allSelected]); 
        if(input.text==="Assessment"){
            props.setAssessmentFilter(1)
        }
        if(input.text==="Classes"){
            props.setClassFilter(1)            
        }
        if(input.text==="Notifications"){
            props.setNotificationFilter(1)                   
        }
        if(input.text==="Mentions"){
            props.setMentionFilter(1)            
        }
        if(input.text==="Replies"){
            props.setReplyFilter(1)            
        }
        if(input.text==="Unread"){
            props.setUnReadFilter(1)            
        }  
        setShowFilter(false)      
    }

    const removeFilterItem = (input, index) =>{
        const ls = [...tempFilter];
        const allSelected = [...selectedItem];
        if(index === -1){
            index = allSelected.findIndex((item) => item.text===input.text);
        }
        ls.splice(index, 1);
        allSelected.splice(index, 1);
        setTempFilter([...ls]);
        setSelectedItem([...allSelected]);
        if(input.text==="Assessment"){
            props.setAssessmentFilter(0)
        }
        if(input.text==="Classes"){
            props.setClassFilter(0)            
        }
        if(input.text==="Notifications"){
            props.setNotificationFilter(0)                   
        }
        if(input.text==="Mentions"){
            props.setMentionFilter(0)            
        }
        if(input.text==="Replies"){
            props.setReplyFilter(0)            
        }
        if(input.text==="Unread"){
            props.setUnReadFilter(0)            
        } 
    }

    useEffect(()=>{
        if(showPinned){
            const payload = { 
                room_id: sid ? sid : props.subjectContent.subject.id, 
            }
            GetPinnedMessages(payload).then((res)=>{
                if(res.status === 200){
                    setPinnedMessages(res?.data)
                }
            })
        }
    },[showPinned, sid])

    const handleShowMessage = (msg) =>{
        props.showMessage(0, msg.id)
    }

    useEffect(() => {
        const handler = setTimeout(() => {
            props.setFeedSearch(searchTerm);
        }, 300);

        return () => {
            clearTimeout(handler); // cleanup on each keystroke
        };
    }, [searchTerm]);

    return (
        <div className='feed-header'>
            <div className='feed-tool-bar'>
                <div className='search-bar-container'>
                    <FeedSearchBar
                        className={`feed-search-bar news-room-search ${selectedItem.length > 0 ? 'has-selected-filter' : ''
                            }`}
                    >
                        <i className="fal fa-search left-icon"></i>
                        <input
                            className="feed-search-input"
                            placeholder="Search"
                            name="search"
                            title="search"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />

                        <div className="filter-item-container">
                            {selectedItem.slice(0, 1).map((item, idx) => (
                                <span className="feed-filter-item" key={idx}>
                                    <i className={`cat ${item.color} fal ${item.icon} mr-1`}></i>
                                    {item.text}
                                    <button
                                        onClick={() => removeFilterItem(item, idx)}
                                        className="remove-filter-item"
                                    >
                                        <i className="fal fa-times"></i>
                                    </button>
                                </span>
                            ))}
                        </div>

                        <span onClick={() => setShowFilter(!showFilter)}>
                            <i className="fal fa-filter right-icon curser" title="Filter"></i>
                            {selectedItem.length > 0 && (
                                <small className="feed-filter-count">
                                    {selectedItem.length}
                                </small>
                            )}
                        </span>
                    </FeedSearchBar>
                    <div className={`feed-filter-dropdown ${showFilter ? "show" : ""}`}>
                        <ul className="feed-filter-group">
                            {selectedItem.map((selectedFilter, idx) => (
                                <li key={idx} className="feed-filter-item">
                                    <i className={`cat ${selectedFilter.color} fal ${selectedFilter.icon}`}></i>
                                    {selectedFilter.text}
                                    <i
                                        className="fal fa-times remove-filter-icon"
                                        onClick={() => removeFilterItem(selectedFilter, -1)}
                                    ></i>
                                </li>
                            ))}

                            {tempFilterData
                                .filter((availableFilter) => !tempFilter.includes(availableFilter.text))
                                .map((availableFilter, idx) => (
                                    <li
                                        key={idx}
                                        onClick={() => handleFilter(availableFilter)}
                                        className="feed-filter-item"
                                    >
                                        <i className={`cat ${availableFilter.color} fal ${availableFilter.icon}`}></i>
                                        {availableFilter.text}
                                    </li>
                                ))}
                        </ul>
                    </div>         
                </div>
                <div className='feed-tool-actions'>
                    <StandardButton
                        variant="white" 
                        outline={true}
                        className=' mr-2' 
                        onClick={()=>{props.showMessage()}}
                        title="Show All Messages"
                    >
                        <i className="fal fa-folder-open"></i> Show All Messages
                    </StandardButton>
                    <StandardButton 
                        variant="white"
                        outline={true}
                        className=' mr-2' 
                        onClick={()=>{props.setTab()}}
                        title="Shared Files"
                    >
                        <i className="fal fa-folder-open"></i> Shared Files
                    </StandardButton>
                    <StandardButton 
                        variant="white"
                        outline={true}
                        className={'btn btn-white-bordered ' + (showPinned ? " active" : "")}
                        title="Pinned Message"
                        onClick={()=>{setShowPinned(!showPinned);}}
                    >
                        <i className="fal fa-thumbtack"></i>
                        Pinned Message
                    </StandardButton>
                </div>            
            </div>
            {showPinned ? 
            pinnedMessages.length > 0 ?
            pinnedMessages.map((message, key) =>(
                <div className='pinned-messages-block' key={key} onClick={()=>{handleShowMessage(message)}}>
                    <div className='card pinned-msg-item' title={message?.subject}>
                        <div className='pinned-msg-left'>
                            <div className='pinned-msg-title'>
                                <span className='pinned-msg-title-head'>
                                    {message?.type == 2 ? 
                                    <>
                                    <i className="fal pin-icon fa-calendar"></i> <span>Pinned Class: </span> 
                                    </>
                                    : message?.type == 3 ?
                                    <>
                                    <i className="fal pin-icon fa-ballot-check"></i> <span>Pinned Assessment: </span> 
                                    </>
                                    : message?.type == 1 ?
                                    <>
                                    <i className="fal pin-icon fa-bell-exclamation"></i> <span>Pinned Notification: </span> 
                                    </>
                                    :<> 
                                    <i className="fal pin-icon fa-thumbtack"></i> <span>Pinned Message: </span> 
                                    </>} 
                                </span>
                                <span className='pinned-msg-title-content'>{message?.subject}</span>                                
                            </div>
                        </div>
                        <div className='pinned-msg-right'>
                            <div className='pinned-msg-date'>
                                <i className="fal fa-calendar-days"></i> {moment(message?.pin_date).format("DD MMM YY HH:mm")}
                            </div>
                            <div className='pinned-msg-action'>
                                <i title="View Message" onClick={()=>{handleShowMessage(message)}} className="fal fa-info-circle"></i>
                            </div>
                        </div>
                    </div>
                </div> 
            ))
            :<p className='text-center'>No Pinned Messages</p>
            : null}
        </div>
    )
}
